(function () {
  'use strict';

  var cfg = window.BongioChatConfig || {};
  var API_URL = cfg.apiUrl || '';
  var isAgent = cfg.isAgent === true;
  // Firmato lato server dal tema (snippet bongio-chat-identity): è l'unica prova
  // di identità che il backend accetta per modalità agente e storico ordini.
  var identityToken = cfg.identityToken || '';
  var currentProductHandle = cfg.currentProductHandle || '';
  var currentCollectionHandle = cfg.currentCollectionHandle || '';

  var history = [];
  var isSending = false;
  var welcomeVisible = true;

  var els = {};

  function init() {
    els.conversation = document.getElementById('hubAiConversation');
    els.messages = document.getElementById('hubAiMessages');
    els.welcome = document.getElementById('hubAiWelcome');
    els.typing = document.getElementById('hubAiTyping');
    els.input = document.getElementById('hubAiInput');
    els.send = document.getElementById('hubAiSend');
    els.suggestions = document.getElementById('hubAiSuggestions');
    els.installBanner = document.getElementById('hubAiInstallBanner');
    els.installClose = document.getElementById('hubAiInstallClose');
    els.installSteps = document.getElementById('hubAiInstallSteps');

    if (!els.input || !els.send) return;

    bindEvents();
    initPWA();
    scrollToSectionIfStandalone();
  }

  /* ---- Events ---- */

  function bindEvents() {
    els.send.addEventListener('click', function () {
      var msg = els.input.value.trim();
      if (msg) sendMessage(msg);
    });

    els.input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        var msg = els.input.value.trim();
        if (msg) sendMessage(msg);
      }
    });

    els.input.addEventListener('input', autoResize);

    var suggestionBtns = document.querySelectorAll('.hub-ai__suggestion');
    for (var i = 0; i < suggestionBtns.length; i++) {
      suggestionBtns[i].addEventListener('click', function () {
        sendMessage(this.getAttribute('data-suggestion'));
      });
    }

    if (els.installClose) {
      els.installClose.addEventListener('click', dismissInstallBanner);
    }
  }

  function autoResize() {
    els.input.style.height = 'auto';
    els.input.style.height = Math.min(els.input.scrollHeight, 160) + 'px';
  }

  /* ---- PWA Install Banner ---- */

  var deferredPrompt = null;

  function initPWA() {
    if (window.matchMedia('(display-mode: standalone)').matches) return;
    if (localStorage.getItem('bongio-ai-install-dismissed')) return;

    var isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    var isAndroid = /Android/.test(navigator.userAgent);

    if (!isIOS && !isAndroid) return;

    if (isIOS) {
      showInstallBanner([
        'Tocca il pulsante <strong>Condividi</strong> (icona quadrato con freccia)',
        'Seleziona <strong>Aggiungi a Home</strong>',
        'Conferma toccando <strong>Aggiungi</strong>'
      ]);
    }

    window.addEventListener('beforeinstallprompt', function (e) {
      e.preventDefault();
      deferredPrompt = e;
      showInstallBanner([
        'Tocca <strong>Installa</strong> quando richiesto dal browser',
        'Oppure: menu ⋮ → <strong>Aggiungi a schermata Home</strong>'
      ]);
    });
  }

  function showInstallBanner(steps) {
    if (!els.installBanner || !els.installSteps) return;
    els.installSteps.innerHTML = steps.map(function (s) {
      return '<li>' + s + '</li>';
    }).join('');
    els.installBanner.classList.add('visible');
  }

  function dismissInstallBanner() {
    if (els.installBanner) els.installBanner.classList.remove('visible');
    localStorage.setItem('bongio-ai-install-dismissed', '1');
  }

  function scrollToSectionIfStandalone() {
    if (!window.matchMedia('(display-mode: standalone)').matches) return;
    var section = document.getElementById('ai-assistant');
    if (section) {
      setTimeout(function () {
        section.scrollIntoView({ behavior: 'auto' });
      }, 100);
    }
  }

  /* ---- Rendering helpers ---- */

  // Escape completo, virgolette incluse: URL e titoli finiscono dentro attributi href/src/alt.
  function esc(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMarkdown(text) {
    var html = esc(text);
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/\n- (.+)/g, function (_, item) {
      return '\n<li>' + item + '</li>';
    });
    html = html.replace(/(<li>[\s\S]*?<\/li>)+/g, function (list) {
      return '<ul>' + list + '</ul>';
    });
    html = html.replace(/\n/g, '<br>');
    html = html.replace(/<br>(<ul>)/g, '$1');
    html = html.replace(/(<\/ul>)<br>/g, '$1');
    return html;
  }

  var FILE_PATTERN = /\[FILE:(pdf|dwg|3d):(https?:\/\/[^\s\]]+):([^\]]+)\]/g;
  var PRODUCT_PATTERN = /\[PRODUCT:([^:\]]+):([^:\]]+):([^:\]]*?):(https?:\/\/[^\s\]]*|)\]/g;

  function renderFileCards(text) {
    FILE_PATTERN.lastIndex = 0;
    return text.replace(FILE_PATTERN, function (_, type, url, name) {
      var iconClass = type === 'pdf' ? 'hub-ai__file-icon--pdf' : 'hub-ai__file-icon--dwg';
      var iconLabel = type === 'pdf' ? 'PDF' : 'DWG';
      var ext = type === 'pdf' ? 'PDF' : '3D (DWG)';
      return '<a class="hub-ai__file-card" href="' + esc(url) + '" target="_blank" rel="noopener" download>' +
        '<div class="hub-ai__file-icon ' + iconClass + '">' + iconLabel + '</div>' +
        '<div class="hub-ai__file-info">' +
          '<div class="hub-ai__file-name">' + esc(name) + '</div>' +
          '<div class="hub-ai__file-meta">' + ext + '</div>' +
        '</div>' +
        '<span class="hub-ai__file-dl">Scarica</span>' +
      '</a>';
    });
  }

  function renderProductCards(text) {
    PRODUCT_PATTERN.lastIndex = 0;
    var cards = '';
    var match;
    while ((match = PRODUCT_PATTERN.exec(text)) !== null) {
      var handle = match[1];
      var title = match[2];
      var ptype = match[3];
      var image = match[4];
      var href = '/products/' + encodeURIComponent(handle);
      var imgHtml = image
        ? '<img class="hub-ai__prod-img" src="' + esc(image) + '" alt="' + esc(title) + '" loading="lazy">'
        : '<div class="hub-ai__prod-img hub-ai__prod-img--empty"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#bbb" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M3 16l5-5 4 4 3-3 6 6"/><circle cx="15" cy="9" r="2"/></svg></div>';
      cards += '<a class="hub-ai__prod-card" href="' + href + '" target="_blank" rel="noopener">' +
        imgHtml +
        '<div class="hub-ai__prod-info">' +
          '<div class="hub-ai__prod-title">' + esc(title) + '</div>' +
          (ptype ? '<div class="hub-ai__prod-type">' + esc(ptype) + '</div>' : '') +
        '</div>' +
      '</a>';
    }
    return cards;
  }

  function formatResponse(text) {
    var cleaned = text.replace(/\[Fonte:[^\]]*\]/g, '').trim();

    FILE_PATTERN.lastIndex = 0;
    PRODUCT_PATTERN.lastIndex = 0;

    var fileCardsHtml = '';
    var productCardsHtml = '';
    var textWithoutTags = cleaned;

    var fileMatches = cleaned.match(FILE_PATTERN);
    if (fileMatches) {
      fileCardsHtml = renderFileCards(cleaned);
      FILE_PATTERN.lastIndex = 0;
      textWithoutTags = textWithoutTags.replace(FILE_PATTERN, '');
    }

    PRODUCT_PATTERN.lastIndex = 0;
    var productMatches = cleaned.match(PRODUCT_PATTERN);
    if (productMatches) {
      productCardsHtml = renderProductCards(cleaned);
      PRODUCT_PATTERN.lastIndex = 0;
      textWithoutTags = textWithoutTags.replace(PRODUCT_PATTERN, '');
    }

    textWithoutTags = textWithoutTags.replace(/\[(?:PRODUCT|FILE):[^\]]*$/g, '').trim();

    var html = formatMarkdown(textWithoutTags);

    if (fileCardsHtml) {
      html += '<div class="hub-ai__cards-row">' + fileCardsHtml + '</div>';
    }
    if (productCardsHtml) {
      html += '<div class="hub-ai__cards-grid">' + productCardsHtml + '</div>';
    }

    return html;
  }

  /* ---- Message rendering ---- */

  function hideWelcome() {
    if (!welcomeVisible) return;
    if (els.welcome) els.welcome.style.display = 'none';
    welcomeVisible = false;
  }

  function addUserMessage(text) {
    hideWelcome();
    var msg = document.createElement('div');
    msg.className = 'hub-ai__msg hub-ai__msg--user';
    msg.innerHTML =
      '<div class="hub-ai__msg-body">' +
        '<div class="hub-ai__msg-content">' + esc(text) + '</div>' +
      '</div>' +
      '<div class="hub-ai__msg-avatar hub-ai__msg-avatar--user">Tu</div>';
    els.messages.appendChild(msg);
    scrollToBottom();
  }

  function addBotMessage() {
    hideWelcome();
    var msg = document.createElement('div');
    msg.className = 'hub-ai__msg hub-ai__msg--ai';

    var contentEl = document.createElement('div');
    contentEl.className = 'hub-ai__msg-content';

    var bodyEl = document.createElement('div');
    bodyEl.className = 'hub-ai__msg-body';
    bodyEl.appendChild(contentEl);

    msg.innerHTML = '<div class="hub-ai__msg-avatar hub-ai__msg-avatar--ai">B</div>';
    msg.appendChild(bodyEl);
    els.messages.appendChild(msg);
    scrollToBottom();

    return { msg: msg, content: contentEl, body: bodyEl };
  }

  function addSources(bodyEl, sources) {
    if (!sources || sources.length === 0) return;
    var srcDiv = document.createElement('div');
    srcDiv.className = 'hub-ai__msg-sources';
    srcDiv.textContent = sources.map(function (s) {
      return '[' + s.label + ']';
    }).join(' ');
    bodyEl.appendChild(srcDiv);
  }

  function showError(msg) {
    hideWelcome();
    var err = document.createElement('div');
    err.className = 'hub-ai__error';
    err.textContent = msg || 'Si è verificato un errore. Riprova tra qualche istante.';
    els.messages.appendChild(err);
    scrollToBottom();
  }

  function showTyping() {
    if (els.typing) els.typing.classList.add('visible');
    scrollToBottom();
  }

  function hideTyping() {
    if (els.typing) els.typing.classList.remove('visible');
  }

  function scrollToBottom() {
    // no-op: disabled to prevent page jumping
  }

  /* ---- API call ---- */

  function sendMessage(text) {
    if (isSending || !text.trim()) return;
    isSending = true;

    els.input.value = '';
    els.input.style.height = 'auto';
    els.send.disabled = true;

    addUserMessage(text);
    history.push({ role: 'user', content: text });
    showTyping();

    var body = JSON.stringify({
      message: text,
      history: history.slice(-20),
      isAgent: isAgent,
      identityToken: identityToken || undefined,
      currentProductHandle: currentProductHandle || undefined,
      currentCollectionHandle: currentCollectionHandle || undefined
    });

    fetch(API_URL + '/api/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: body
    })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);

        var contentType = response.headers.get('content-type') || '';
        if (contentType.indexOf('application/json') !== -1) {
          return response.json().then(function (data) {
            hideTyping();
            var bot = addBotMessage();
            bot.content.innerHTML = formatResponse(data.text);
            history.push({ role: 'assistant', content: data.text });
            finish();
          });
        }

        var reader = response.body.getReader();
        var decoder = new TextDecoder();
        var buffer = '';
        var fullText = '';
        var bot = null;

        function processChunk(result) {
          if (result.done) { finish(); return; }

          buffer += decoder.decode(result.value, { stream: true });
          var lines = buffer.split('\n');
          buffer = lines.pop() || '';

          for (var i = 0; i < lines.length; i++) {
            var line = lines[i].trim();
            if (!line.startsWith('data: ')) continue;

            try {
              var data = JSON.parse(line.slice(6));
            } catch (e) { continue; }

            if (data.error) {
              hideTyping();
              showError(data.error);
              finish();
              return;
            }

            if (data.token) {
              if (!bot) {
                hideTyping();
                bot = addBotMessage();
              }
              fullText += data.token;
              bot.content.innerHTML = formatResponse(fullText);
              scrollToBottom();
            }

            if (data.done) {
              history.push({ role: 'assistant', content: fullText });
              finish();
              return;
            }
          }

          return reader.read().then(processChunk);
        }

        return reader.read().then(processChunk);
      })
      .catch(function (err) {
        console.error('[hub-ai] error:', err);
        hideTyping();
        showError();
        finish();
      });

    function finish() {
      isSending = false;
      els.send.disabled = false;
      els.input.focus();
    }
  }

  /* ---- Init ---- */

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
